<template>
    <div class="addBox relative">
        <div class="title">
            <div class="title_left"><span class="movePoin" @click="$router.go(-1)">晨检 </span> / <span class="type">查看详情</span></div>
        </div>
        <el-form label-width="150px">
            <ToggleForm title="基本信息">
                <div class="content">
                    <div class="row mt20">
                        <el-form-item label="被检查人：">
                            {{inspectRecord.checker}}
                        </el-form-item>
                    </div>
                    <div class="row">
                        <el-form-item label="检查时间：">
                            {{inspectRecord.inspectDate}}
                        </el-form-item>
                    </div>
                    <div class="row">
                        <el-form-item label="检查人：">
                           {{inspectRecord.inspected}}
                        </el-form-item>
                    </div>
                </div>
            </ToggleForm>
            <ToggleForm title="晨检明细表">
                <div class="content">
                    <div class="tabOffTop120">
                        <!-- v-loading="loading" element-loading-text="数据正在努力加载中"  -->
                        <el-table ref="multipleTable" :data="inspectRecord.tableData" tooltip-effect="dark" style="width: 100%">
                            <el-table-column label="被检查人" width="80" show-overflow-tooltip>
                                <template slot-scope="scope">{{ scope.row.empName}}</template>
                            </el-table-column>
                            <el-table-column prop="empPost" label="职务" width="80" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column  label="发热">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('0001')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('0001')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="外伤">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('0002')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('0002')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="呕吐腹泻">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('0003')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('0003')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="皮肤疾病">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('0005')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('0005')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="其它疾病">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('5000')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('5000')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="着装不规范">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('5001')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('5001')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="双手不干净">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('5002')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('5002')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="指甲过长">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('5003')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('5003')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="戒指等饰品">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('5004')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('5004')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="其它卫生问题" width="120">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.problemItemCode.includes('9999')" class="yes">合格</span>
                                    <span v-if="scope.row.problemItemCode.includes('9999')" class="yes no">不合格</span>
                                </template>
                            </el-table-column>
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <el-table :data="props.row.problem" tooltip-effect="dark" style="width: 100%">
                                        <el-table-column label="序号" width="180">
                                            <template slot-scope="scope">{{ scope.row.date }}</template>
                                        </el-table-column>
                                        <el-table-column prop="name" label="问题" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column prop="address" label="处理结果" show-overflow-tooltip>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </ToggleForm>
            <ToggleForm title="图片附件">
                <div class="content">
                    <div class="row rowybUpload">
                        <el-form-item label="图片附件：">
                            <div class="imgbox" v-if="inspectRecord.fileDTOList.length >= 1">
                                <div v-for="(item,index) in inspectRecord.fileDTOList" :key="index" @click.stop="ifbig(item.fileUrl)" class="imgdiv">
                                    <img :src="item.fileUrl">
                                    <span>预览</span>
                                </div>
                            </div>
                            <div class='big-img' v-show="showBigPic" @click.stop="ifbig('-1')">
                                <img :src="bigImgSrc">
                            </div>
                            <div v-if="inspectRecord.fileDTOList.length == 0">
                                <span>暂无</span>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="row mt20">
                        <el-form-item label="备注：" prop="remark" class="clear_a">
                           {{inspectRecord.remark}}
                        </el-form-item>
                    </div>
                </div>
            </ToggleForm>
        </el-form>
        <div class="foot-btn">
            <div>
                <el-button class="w70 mr10" @click="$router.go(-1)">返回</el-button>
                <el-button type="primary w70 ">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ToggleForm from "components/ToggleForm";
    import ybUpload from "components/ybUpload";
    export default {
        name: "inspectDetail",
        components:{ToggleForm,ybUpload},
        data(){
            return{
                bigImgSrc: null,//拍照图片查看路径
                showBigPic: false,//拍照图片查看是否显示
                inspectRecord:{
                    inspectDate:'2019-12-12',
                    checkerList:[
                        {
                            empId:'jdjjdd',
                            empName:'人类'
                        },
                        {
                            empId:'eekkek',
                            empName:'天仙'
                        },
                        {
                            empId:'lolol',
                            empName:'小喽啰'
                        },
                    ],
                    inspectedPersonList:[
                        {
                            empId:'ooww',
                            empName:'好多人'
                        },
                        {
                            empId:'swwww',
                            empName:'特别多的人突突突突突突拖'
                        },
                        {
                            empId:'uuyy',
                            empName:'人呀呀呀突突突突突突拖拖拖拖拖拖'
                        },
                        {
                            empId:'kokok',
                            empName:'人囖囖咯囖咯哒哒哒哒哒哒多多'
                        },
                        {
                            empId:'kokokgg',
                            empName:'人囖囖咯囖咯哒哒哒哒哒哒多多'
                        },
                    ],
                    fileDTOList:[
                        {
                            fileId:'55555',
                            fileUrl:'http://stg-res-test.ybveg.com/tog_test/13dab5520c2d4265a8c9a7711c4de485.jpeg'
                        }
                    ],
                    remark:'这是备注备注备注备注备注啊',
                    tableData: [
                        {
                            empName: "人啊啊啊啊啊啊啊啊啊啊啊",
                            empPost: "就觉得决定,的开导开导看,发发发,发发发",
                            inspector:'就觉得决定,的开导开导看,发发发,发发发',
                            remark:'这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊',
                            problemItemCode:'0001, 0002'
                        },
                        {
                            empName: "是人啊啊",
                            empPost: "就觉得决定,的开导开导看,发发发,发发发",
                            inspector:'就觉得决定,的开导开导看,发发发,发发发',
                            remark:'这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊',
                            problemItemCode:'0003, 0004'
                        },
                        {
                            empName: "哈哈",
                            empPost: "就觉得决定,的开导开导看,发发发,发发发",
                            inspector:'就觉得决定,的开导开导看,发发发,发发发',
                            remark:'这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊',
                            problemItemCode:'0001, 0002'
                        },
                        {
                            empName: "嘻嘻嘻",
                            empPost: "就觉得决定,的开导开导看,发发发,发发发",
                            inspector:'就觉得决定,的开导开导看,发发发,发发发',
                            remark:'这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊',
                            problemItemCode:'0001, 0002'
                        },
                        {
                            empName: "哟哟哟",
                            empPost: "王小虎",
                            inspector:'就觉得决定,的开导开导看,发发发,发发发',
                            remark:'这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊',
                            problemItemCode:'0001, 0002'
                        },
                        {
                            empName: "稀拉拉阿拉哈",
                            empPost: "王小虎",
                            inspector:'就觉得决定,的开导开导看,发发发,发发发',
                            remark:'这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊',
                            problemItemCode:'0001, 0002'
                        },
                        {
                            empName: "嘻嘻哈哈哈啦啦啦",
                            empPost: "王小虎",
                            inspector:'就觉得决定,的开导开导看,发发发,发发发',
                            remark:'这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊',
                            problemItemCode:'0001, 0002'
                        }
                    ]

                },
                multipleSelection:[]
            }
        },
        methods:{
             getData(){
                this.transformList(this.inspectRecord.checkerList, 'checker','checker');
                this.transformList(this.inspectRecord.inspectedPersonList, 'inspected','inspected');
            },
            transformList(list,key,check){
                let result = [];
                if(list !== null){
                    if(check){
                        list.map(item => {
                            result.push(item.empName)
                        })
                    }else{
                        list.map(item => {
                            if(item.processResult == ''){
                                item.processResult = '暂无处理结果'
                            }
                            let data = `${item.empName}(${item.processResult})`
                            result.push(data)
                        })
                    }
                    this.inspectRecord[key] = result.join()
                }else {
                    this.inspectRecord[key] = list
                }
            },
            ifbig(item) {
                if (this.bigImgSrc == null || this.bigImgSrc != item) {
                    this.bigImgSrc = item;
                    this.showBigPic = true;
                } else {
                    this.bigImgSrc = null;
                }
                if (item == -1) {
                    this.showBigPic = false;
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            }
        },
        mounted(){
            this.getData();
        }
    }
</script>

<style scoped lang="scss">
    .addBox{
        width: calc(100% - 40px);
        min-height: 100%;
        padding: 0 20px 100px 20px;
        .title{
            height: 60px;
            line-height: 60px;
            .title_left{
                font-size: 20px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                width: 50%;
                height: 100%;
                .type{
                    color:#70CE97;
                }
            }
        }
    }

    // 图片列表
    .imgbox {
        // display: flex;
        width: 650px;
        // overflow: hidden;
    }

    .imgdiv {
        float: left;
        width: 130px;
        height: 130px;
        border: 1px solid #C2CAD2;
        border-radius: 6px;
        position: relative;
        margin-right: 20px;
        margin-top: 10px;
        img {
            transition: all 0.5s;
            width: 100%;
            height: 100%;
            border-radius: 6px;
        }
        span {
            display: none;
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: rgba(0, 0, 0, 0.40);
            border-radius: 0 0 5px 5px;
            font-size: 14px;
            color: #FFFFFF;
            position: absolute;
            bottom: 0;
            left: 0;
        }
    }
    .imgdiv:hover {
        span {
            display: inline-block;
        }
    }
    .big-img {
        height: 100%;
        width: 100%;
        position: fixed;
        left: 0px;
        top: 0px;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
        >img {
            display: block;
            max-height: 700px;
        }
    }

    .content{
        padding: 30px;
        .yes{
            font-size: 12px;
            text-align: center;
            line-height: 25px;
            display: inline-block;
            width:50px;
            height:24px;
            border-radius:4px;
            border:1px solid rgba(112,206,151,1) !important;
            color: rgba(112,206,151,1);
            cursor: pointer;
        }
        .no{
            border:1px solid #ED8C98 !important;
            color: #ED8C98;
        }
    }
</style>